import { X } from 'lucide-react';

// Token van de vibbo-walkthrough "Aan de slag" (D1 opname-welcome, slug aan-de-slag).
const WALKTHROUGH_URL = 'https://vibbo.nl/w/eyDaq115nnF4VrKcmmgXcxtRs-F43hJ05gHCkxzjJJ8';

interface Props {
  onClose: () => void;
}

export function WalkthroughOverlay({ onClose }: Props) {
  return (
    <div className="fixed inset-0 z-50 bg-black/70 flex items-center justify-center p-4" role="dialog" aria-modal="true" aria-label="Rondleiding: Aan de slag">
      <div className="w-full max-w-4xl">
        <div className="relative w-full aspect-video rounded-xl overflow-hidden bg-[#EDEBE7] shadow-2xl">
          <iframe
            src={WALKTHROUGH_URL}
            title="Rondleiding: Aan de slag"
            className="absolute inset-0 w-full h-full border-0"
            allow="autoplay; fullscreen"
            allowFullScreen
          />
        </div>
        <div className="flex justify-center mt-4">
          <button
            type="button"
            onClick={onClose}
            className="bg-white text-[#231F20] text-sm font-semibold px-6 py-2.5 rounded-lg hover:bg-gray-100 transition-colors inline-flex items-center gap-2"
          >
            <X className="w-4 h-4" /> Sluiten
          </button>
        </div>
      </div>
    </div>
  );
}
